import React from "react";
import { Button, Modal } from "react-bootstrap";

const AppraisalCongirmationModal = ({
  show,
  handleClose,
  submitAppraisalData,
  data,
  overAllAppraisal,
}) => {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      onHide={handleClose}
    >
      <Modal.Header style={{ borderBottom: "0px" }}>
        <div className="text-end w-100">
          <i
            class="fa-solid fa-xmark"
            onClick={handleClose}
            // style={{ marginRight: "-10px" }}
          ></i>
        </div>
      </Modal.Header>
      <Modal.Body>
        <h4 className="text-center">
          Appraisal Submission for{" "}
          {data[0]?.first_name || data[0]?.goal_employee_first_name}{" "}
          {data[0]?.goal_employee_middle_name}{" "}
          {data[0]?.goal_employee_last_name}
        </h4>
        <p className="text-center">
          Please confirm if you would like to proceed with submitting the
          appraisal for{" "}
          {data[0]?.first_name || data[0]?.goal_employee_first_name}{" "}
          {data[0]?.goal_employee_middle_name}{" "}
          {data[0]?.goal_employee_last_name} with a {overAllAppraisal}%
          increment. Kindly review the details and confirm your approval to
          finalize the submission.
        </p>
        <div className="text-end mt-5">
          <Button
            style={{ marginRight: "10px" }}
            onClick={handleClose}
            variant="secondary" // Changed 'muted' to 'secondary'
          >
            Close
          </Button>
          <Button
            variant={`success`}
            onClick={submitAppraisalData} // Disable if total weightage exceeds 100
          >
            Submit Appraisal
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AppraisalCongirmationModal;
